import React from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import { message } from 'antd';

import { getAllCategories, removeMainCategory, removeSubCategory } from './actions';

import CategoryRow from './category-row';
import { _getGoogleTaxonomies, _postDeleteMainCategory, _postDeleteSubCategory, _getCategoryMainStats } from '../../services';

import { URL_ENDPOINT } from '../../index';

import './index.css';

class Category extends React.Component {
	render() {

		const { categories } = this.props;
		const { mainCategoryStats, googleTaxonomies } = this.state;

		if (!categories.data || !googleTaxonomies || googleTaxonomies.length === 0) {
			return <div>Loading...</div>;
		}

		const sortedCategories = this.getSortedCategories(categories)

		return (
			<div>
				{/* <Button onClick={ () => { this.setState({ expandAll: !this.state.expandAll })} }>Expand All</Button> */}
				{sortedCategories.map(
					(mainCategory, mainIndex) => (
						<CategoryRow

							expanded={this.state.expandAll}

							deleteMainCategoryTitle={this.deleteMainCategoryTitle}
							deleteSubCategoryTitle={this.deleteSubCategoryTitle}

							googleTaxonomies={this.state.googleTaxonomies}

							key={mainIndex}
							index={mainIndex}
							mainCategoryAmount={mainCategoryStats && mainCategoryStats[mainCategory.titleUrl]} />
					)
				)}
			</div>
		);
	}

	state = {
		open: {},
		expandAll: false
	};

	/**
	 * @todo - to remove if server-side adds sorting.
	 */
	getSortedCategories(categories)  {
		/**
		 * Sort Categories
		 */
		const sortedCategories = categories.data.sort((a, b) => {

			if (a.titleUrl > b.titleUrl) {
				return 1;
			} else {
				return - 1;
			}
		});
		/**
		 * Sort Sub Categories
		 */
		const sortedCategoriesFull = sortedCategories.map(category => {
			if (category.children && category.children.length !== 0) {
				category.children.sort((a, b) => {
					if (a.titleUrl > b.titleUrl) {
						return 1;
					} else {
						return - 1;
					}
				});
			}

			return category;
		});

		return sortedCategoriesFull
	};

	shouldComponentUpdate(nextProps, nextState) {
		// return true;

		// if( this.state.expandAll !== nextState.expandAll ){
		// 	return true;
		// }

		if (this.props.categories.loading && !nextProps.categories.loading) {
			return true;
		}

		if (this.props.categories.data.length !== nextProps.categories.data.length) {
			return true;
		}

		if (!this.state.mainCategoryStats && nextState.mainCategoryStats) {
			return true;
		}

		if (!this.state.googleTaxonomies && nextState.googleTaxonomies) {
			return true;
		}

		return false;

	}

	componentWillMount() {
		this.props.getAllCategories();

		_getGoogleTaxonomies()
			.then(res => {
				this.setState({
					googleTaxonomies: res.data
				});
			});

		_getCategoryMainStats()
			.then(res => {
				const mainCategoryStats = res.data.reduce(
					(acc, cur) => {

						acc[cur._id] = cur.count;

						return acc;
					}, {}
				);

				console.log(mainCategoryStats);

				this.setState({
					mainCategoryStats
				});
			});
	}

	deleteMainCategoryTitle = (mainIndex) => {

		const mainCategory = this.props.categories.data[mainIndex];

		message.loading(`Deleting ${mainCategory.title}`, 0);

		_postDeleteMainCategory({
			mainCategory
		}).then(res => {
			message.destroy();
			message.success(`Deleted ${mainCategory.title}`);

			this.props.removeMainCategory({ mainCategory });
		}).catch((err) => {
			message.destroy();
			message.error(err.response.data);
		});

	};

	deleteSubCategoryTitle = (mainIndex, subIndex) => {

		const mainCategory = this.props.categories.data[mainIndex];
		const subCategory = this.props.categories.data[mainIndex].children[subIndex];

		message.loading(`Deleting ${subCategory.title}`, 0);

		_postDeleteSubCategory({
			mainCategory,
			subCategory
		}).then(res => {
			message.destroy();
			message.success(`Deleted ${subCategory.title}`);

			this.props.removeSubCategory({ mainCategory, subCategory });

		}).catch((err) => {
			message.destroy();
			message.error(err.response.data);
		});
		// axios({
		// 	withCredentials: true,
		// 	url: `${URL_ENDPOINT}/api/category/sub/${mainCategory._id}`,
		// 	method: 'post',
		// 	data:subCategory
		// })
		// 	.then( () => {
		// message.destroy();
		// message.success(`Saved ${subCategory.title}`);
		// 	})
		// 	.catch( (res) => {
		// 		message.destroy();
		// 		message.error(`Error saving ${subCategory.title}`);
		// 	})
	};
}

export default connect(
	state => ({
		categories: state.categories
	}),

	dispatchEvent => ({
		getAllCategories: () => dispatchEvent(getAllCategories()),
		removeMainCategory: ({ mainCategory }) => dispatchEvent(removeMainCategory({ mainCategory })),
		removeSubCategory: ({ mainCategory, subCategory }) => dispatchEvent(removeSubCategory({ mainCategory, subCategory }))
	})
)(Category);


// WEBPACK FOOTER //
// ./src/components/category/index.js